import React from 'react'
import { ArrowIcon } from './Icons'

export function SiteNavigationHeader({ siteName, onPrevSite, onNextSite, totalSites, currentIndex }) {
  return (
    <div className="site-navigation-header">
      <button 
        className="site-nav-arrow"
        onClick={onPrevSite}
        aria-label="Previous site"
      >
        <ArrowIcon className="-flip" />
      </button>
      <div className="site-name">
        <span className="-small">Site {currentIndex + 1} of {totalSites}</span>
        <h4>{siteName}</h4>
      </div>
      <button 
        className="site-nav-arrow"
        onClick={onNextSite}
        aria-label="Next site"
      >
        <ArrowIcon />
      </button>
    </div>
  )
}

